import api from "../lib/apiClient";
export const login = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);
export const register = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const getUserProfile = () => api.get("/auth/me").then((r) => r.data);
export const updateProfile = (payload) => api.patch("/profile", payload).then((r) => r.data);
export const logout = () => api.post("/auth/logout").then((r) => r.data);
